<button
  class="button"
  (click)="clicked.emit($event)"
  [disabled]="disabled()"
  [class.primary]="type() === 'primary'"
  [class.primary-dark]="type() === 'primary-dark'"
  [class.primary-darker]="type() === 'primary-darker'"
  [class.secondary]="type() === 'secondary'"
  [class.payment]="type() === 'payment'"
  [class.ghost]="type() === 'ghost'"
  [class.uppercase]="uppercase()"
  [class.icon-left]="iconLeft()"
  [class.icon-right]="iconRight()"
  [class.square-border]="border() === 'square'"
  [class.small]="size() === 'sm'"
  [class.medium]="size() === 'md'"
  [class.large]="size() === 'lg'"
  [class.extra-large]="size() === 'xl'"
  [class.left-icon-background]="leftIconBackground()"
  [class.right-icon-background]="rightIconBackground()"
  [class.letter-spacing-wide]="letterSpacing() === 'wide'"
>
  @if (iconLeft()) {
    <app-icon class="button-icon" glyph [name]="iconLeft()"/>
  }
  @if (label() && label2()) {
    <div class="label-container" [class.vertical]="label2()">
      <span>{{ label() }}</span>
      <span>{{ label2() }}</span>
    </div>
  } @else {
    {{ label() }}
  }
  @if (iconRight()) {
    <app-icon class="button-icon" glyph [name]="iconRight()"/>
  }
  <ng-content [left]></ng-content>
</button>
